/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryTransactionDtoPage } from '../../models/inventory-transaction-dto-page';

export interface ListInventoryTransactions$Params {
  query?: string;
  inventoryItemIds?: Array<string>;
  workPackageIds?: Array<string>;
  excludeIds?: Array<string>;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'date' | '-date' | 'quantity' | '-quantity' | 'type' | '-type' | 'inventoryItem' | '-inventoryItem' | 'inventoryItemName' | '-inventoryItemName' | 'inventoryItemCode' | '-inventoryItemCode' | 'workPackage' | '-workPackage' | 'comment' | '-comment' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listInventoryTransactions(http: HttpClient, rootUrl: string, params?: ListInventoryTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryTransactionDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listInventoryTransactions.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('inventoryItemIds', params.inventoryItemIds, {});
    rb.query('workPackageIds', params.workPackageIds, {});
    rb.query('excludeIds', params.excludeIds, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InventoryTransactionDtoPage>;
    })
  );
}

listInventoryTransactions.PATH = '/v0/inventoryTransactions';
